import { getRandomUniqueId } from "./getRandomUniqueId";

export const getSetFromLocalStorage = (keyName) => {
    const dataFromStorage = localStorage.getItem(keyName) 
    
    if(dataFromStorage){
        return dataFromStorage;
    } else {
        const id = getRandomUniqueId();
        localStorage.setItem(keyName, id);
        return id;
    }
}